import SimpleCard from "../cards/SimpleCard";

export default function SummaryCard({ icon, label, value, variant = "primary" }) {
  return <SimpleCard className={`h-100 border-start border-4 border-${variant}`}>
    <div className="d-flex align-items-center gap-3">
      <span className={`fs-2 text-${variant}`} aria-hidden="true">{icon}</span>
      <div><span className="small text-muted d-block">{label}</span><strong className="fs-3 text-primary d-block">{value}</strong></div>
    </div>
  </SimpleCard>;
}
